import { Image, Message } from 'semantic-ui-react'

function AppDownloadPage({ tenant }) {
  return (
    <div style={{ padding: "0.5em" }}>
      <div style={{ maxWidth: "46em", margin: "0.5em auto" }}>
        <h1 className="ui center aligned huge header">
          <Image src='/app-icon.png' className='ui image' style={{ margin: "0.5em auto" }} />
          <div className='sub header'>
            {tenant.name || "クリニック"}
            <br />
            公式アプリのご案内
          </div>
        </h1>

        <h3 className='ui center aligned header' style={{ color: "gray" }}>
          アプリ完結。診察券の持ち歩きは不要です。
        </h3>

        <div className='ui container' style={{ display: "flex", justifyContent: "center", padding: "2em 0" }}>
          <div className='ui list'>
            <div className='item'>
              <i className='teal check icon'></i>
              <div className='content'>ご予約（患者登録・予約取り・予約変更・キャンセル）</div>
            </div>
            <div className='item'>
              <i className='teal check icon'></i>
              <div className='content'>ご予約のキャンセル待ちエントリー</div>
            </div>
            <div className='item'>
              <i className='teal check icon'></i>
              <div className='content'>ご予約前日のリマインド通知</div>
            </div>
            <div className='item'>
              <i className='teal check icon'></i>
              <div className='content'>ご来院の受付</div>
            </div>
            <div className='item'>
              <i className='teal check icon'></i>
              <div className='content'>在院中の待ち状況案内・お呼び出し</div>
            </div>
            <div className='item'>
              <i className='teal check icon'></i>
              <div className='content'>ご家族登録（1台のスマホで複数患者を登録可能）</div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: "0.75em", padding: "0.5em", flexWrap: "wrap" }}>
          {tenant.android_app_id &&
            <div className='ui center aligned'>
              <p>Androidの方</p>
              <a href={`https://play.google.com/store/apps/details?id=${tenant.android_app_id}`}>
                <Image src='/google-play-badge.png' size='small' alt='Google Play で手に入れよう' />
              </a>
            </div>
          }

          {tenant.ios_app_id &&
            <div className='ui center aligned'>
              <p>iPhoneの方</p>
              <a href={`https://apps.apple.com/jp/app/id${tenant.ios_app_id}`}>
                <Image src='/app-store-badge.png' size='small' alt='App Store からダウンロード' />
              </a>
            </div>
          }
        </div>

        {!tenant.android_app_id && !tenant.ios_app_id &&
          <Message warning style={{ marginTop: "1em" }}>
            現在ダウンロード情報が設定されていません。
          </Message>
        }
      </div>
    </div>
  );
}

export default AppDownloadPage;
